import artworkFrag from "./Artwork";
import photoMaterialFrag from "./PhotoMaterial";

const Image = ({
  artwork = false,
  artworkId = true,
  archiveId = true,
  channelDisplayOnline = false,
  description = false,
  downloadPath = false,
  imgT = true,
  imgX = true,
  imgA = false,
  imgB = false,
  jpegUrls = false,
  order = false,
  photoMaterial = false,
  photoMaterialId = false,
  updatedAt = false,
  uploadedAt = false,
  urls = false,
  xDownloadPath = false,
} = {}) => `
  ${
    artwork
      ? `artwork {
      ${artworkFrag(artwork)}
    }`
      : ""
  }
  ${artworkId ? "artworkId" : ""}
  ${archiveId ? "archiveId" : ""}
  ${channelDisplayOnline ? "channelDisplayOnline" : ""}
  ${description ? "description" : ""}
  ${downloadPath ? "downloadPath" : ""}
  ${imgT ? `imgT` : ""}
  ${imgX ? `imgX` : ""}
  ${imgA ? `imgA` : ""}
  ${imgB ? `imgB` : ""}
  ${jpegUrls ? `jpegUrls` : ""}
  ${order ? "order" : ""}
  ${photoMaterialId ? "photoMaterialId" : ""}
  ${
    photoMaterial
      ? `photoMaterial {
      ${photoMaterialFrag(photoMaterial)}
    }`
      : ""
  }
  ${updatedAt ? "updatedAt" : ""}
  ${uploadedAt ? "uploadedAt" : ""}
  ${
    urls
      ? `urls {
          href
          artworkId
          archiveId
      }`
      : ""
  }
  ${xDownloadPath ? "xDownloadPath" : ""}
`;

export default Image;
